export function getCsrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content;
}

export function buildJsonHeaders(extraHeaders = {}) {
  const token = getCsrfToken();

  return {
    'X-CSRF-Token': token,
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...extraHeaders,
  };
}
